import {objectUtils} from '@acorn/mycb-ui-common/lib/utils';

// ---------------------------------------------------------------------------------------------------------//
//                              Routes                                                           //
// ---------------------------------------------------------------------------------------------------------//

// main routes
export const HOME = '/bfcp-dashboard';

// ---------------------------------------------------------------------------------------------------------//
//                                Error Routes                                                              //
// ---------------------------------------------------------------------------------------------------------//

// Error Route
export const ERROR = 'error';
export const INVALID_CLOCK_ERROR = 'hdc/invalid-clock';
export const CATAPULT_SUBROUTE = 'hdc/login';

// Error sub route
export const CLOCK_ERROR = `${ERROR}/${INVALID_CLOCK_ERROR}`;
export const CATAPULT_ERROR = `${ERROR}/${CATAPULT_SUBROUTE}`;
export const TIMEOUT_ERROR = CATAPULT_ERROR;

export const ROUTE_MAPPING = objectUtils.deepFreeze({
  MAIN: HOME,
  HOME: {
    MAIN: HOME
  },
  ERROR: {
    CLOCK: CLOCK_ERROR,
    CATAPULT: CATAPULT_ERROR,
    TIMEOUT: TIMEOUT_ERROR
  }
});
export const ROUTE_SET = objectUtils.deepFreeze([HOME, CLOCK_ERROR, CATAPULT_ERROR, TIMEOUT_ERROR]);